import clsx from "clsx";
import { forwardRef, MutableRefObject } from "react";
import { RefCallBack } from "react-hook-form";

import { Visibility } from "../../hooks";
import { FieldItem, GroupItem, ResponseSubmitter } from "../../types";

export const FieldsList = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={clsx("flex flex-col gap-8", className)}>{children}</div>;

export const FieldWrapper = forwardRef<
  HTMLDivElement,
  {
    isLoading?: boolean;
    disabled?: boolean;
    children: React.ReactNode;
    className?: string;
  }
>(({ isLoading, disabled, children, className }, ref) => (
  <div
    ref={ref}
    className={clsx(
      "relative print:break-inside-avoid",
      isLoading && "opacity-50",
      disabled && "pointer-events-none",
      className,
    )}
    aria-disabled={disabled}
  >
    {children}
  </div>
));

export type FieldProps<E = any, V = any> = {
  field: FieldItem;
  index?: number;
  value: V;
  onChange: (value: V) => void;
  onBlur: () => void;
  error?: string;
  innerRef?: RefCallBack | MutableRefObject<E>;
  disabled?: boolean;
  loading?: boolean;
  hideLabel?: boolean;
  isPreview?: boolean;
  showPaymentPlaceholder?: boolean;
};

export type FieldComponentOverrideProps = {
  groups: GroupItem[];
  fields: FieldItem[];
  visibility: Visibility;
  submitResponses: ResponseSubmitter;
  responses: Record<string, any>;
};
